export const getRandomPastelColor = () => {
    // Función auxiliar para generar valores RGB en el rango de pastel (entre 127 y 255)
    function randomChannel() {
        return Math.floor(127 + Math.random() * 128); // Limitar a la mitad superior de 0-255
    }

    // Convertir los valores RGB a formato hexadecimal
    const r = randomChannel().toString(16).padStart(2, '0');
    const g = randomChannel().toString(16).padStart(2, '0');
    const b = randomChannel().toString(16).padStart(2, '0');

    return `#${r}${g}${b}`;
}